import bowser from 'bowser';
import {assert} from './assert';
import {getFirstMatch} from './string';
import {UNKNOWN, IS_CLIENT} from '../constant';
import {getClientStore} from '../store';
import {IUserAgent} from '../type';

export function getUserAgent(userAgentStr?: string): IUserAgent | undefined {
  if (!userAgentStr || userAgentStr === 'kp-static') {
    return undefined;
  }
  const parsed = bowser.getParser(userAgentStr);
  const platform = parsed.getPlatform();
  const userAgent = {} as IUserAgent;
  const os = parsed.getOS();
  const browser = parsed.getBrowser();
  userAgent.version = browser.version || '';
  userAgent.osVersion = os.version || '';
  userAgent.osName = os.name || UNKNOWN;
  userAgent.isMobile = parsed.getPlatformType() === 'mobile';
  userAgent.rawData = userAgentStr;
  userAgent.isWebView = getIsWebView(userAgentStr);
  // os: https://github.com/lancedikson/bowser/blob/master/src/parser-os.js
  userAgent.isAndroid = os.name === 'Android';
  userAgent.isIos = os.name === 'iOS';
  userAgent.isMacOs = os.name === 'macOS';
  // browser: https://github.com/lancedikson/bowser/blob/master/src/constants.js
  userAgent.browserName = browser.name || UNKNOWN;
  userAgent.isChrome = browser.name === 'Chrome';
  userAgent.isFirefox = browser.name === 'Firefox';
  userAgent.isMsie = browser.name === 'Internet Explorer';
  userAgent.isSafari = browser.name === 'Safari';
  userAgent.isSamsungBrowser = browser.name === 'Samsung Internet for Android';
  userAgent.deviceName = platform.model || UNKNOWN;
  checkAndSetPageIosVersion(userAgent, userAgentStr);
  return userAgent;
}

// TODO: 카카오웹툰 ios 앱팀과 협의된 내용은 아님. 아래 함수 호출하지 않고도 bowser 가 osVersion 을 잘 가져오면 함수를 지우자
const regexIosVersion = /kakaowebtoon\/.+iOS (\d+(\.\d+)*);/i;
export function checkAndSetPageIosVersion(
  userAgent: IUserAgent,
  userAgentStr: string
) {
  // 페이지 ios 앱에서 userAgent를 수정하므로 아래 처리가 필요하다
  if (userAgentStr.indexOf('iOS') > 0) {
    const osVersion = getFirstMatch(regexIosVersion, userAgentStr);
    if (osVersion) {
      userAgent.osVersion = osVersion;
    }
  }
}

const REGEX_IS_WEB_VIEW = /(kakaowebtoon)/i;
let isWebView: boolean | undefined;
export function getIsWebView(userAgentStr?: string) {
  if (userAgentStr) {
    return REGEX_IS_WEB_VIEW.test(userAgentStr);
  } else {
    if (isWebView) {
      return isWebView;
    } else if (IS_CLIENT) {
      const _isWebView = REGEX_IS_WEB_VIEW.test(navigator.userAgent);
      isWebView = _isWebView;
      return _isWebView;
    } else {
      assert(false, 'SSR must pass userAgentStr');
      return false;
    }
  }
}

const AND_LITE_MAX_VERSION = 8;
let isLiteVersion: boolean;
export function getIsLiteVersion(userAgent?: IUserAgent) {
  if (!IS_CLIENT || !getClientStore()?.getState().common.isAppMounted)
    return false;

  if (isLiteVersion !== undefined) {
    return isLiteVersion;
  }

  userAgent ??= getUserAgent(window.navigator.userAgent);
  /**
   * 아이폰은 ua 에 모델 정보가 없다
   *   - 정확하진 않지만 화면 너비를 기준으로 계산한다
   *   - lite 이지만 false 가 되는 경우: iPhone 6 Plus(1080px)
   *   - lite 아니지만 true 가 되는 경우: iPhone SE 2020(750px)
   *   - 참고 링크: https://screensiz.es/
   */
  const _isLiteVersion = !!(
    userAgent?.isSamsungBrowser ||
    userAgent?.isMsie ||
    userAgent?.rawData.includes('HeyTapBrowser') || // oppo 자체 브라우저(chrome 기반이라 구분되는 값이 없다.)
    (userAgent?.isAndroid &&
      parseInt(userAgent.osVersion, 10) <= AND_LITE_MAX_VERSION) ||
    (userAgent?.isIos &&
      window.screen.width * window.devicePixelRatio <= 750) ||
    // LG 스탠바이미
    (userAgent?.osName === 'Linux' && userAgent.rawData.includes('SmartTV'))
  );

  isLiteVersion = _isLiteVersion;
  return _isLiteVersion;
}
